import { render, staticRenderFns } from "./CPICert.vue?vue&type=template&id=602560e5&"
import script from "./CPICert.vue?vue&type=script&lang=js&"
export * from "./CPICert.vue?vue&type=script&lang=js&"
import style0 from "./CPICert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports